import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BusinessUnit } from '@delen/connect-core';
import { Observable } from 'rxjs';
import { CONFIG } from '../config/config.token';
import { AuthorizeRequest } from './models/authorize-request';
import { AuthorizeResponse } from './models/authorize-response';
import { TokenRequest } from './models/token-request';
import { TokenResponse } from './models/token-response';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationRepository {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject(CONFIG);

  getRelationPhone(shareId: string, relationId: string, businessUnit: string): Observable<string> {
    const authBaseUrl = this.resolveAuthBaseUrl(businessUnit);
    return this.httpClient.get<string>(`${authBaseUrl}/${shareId}/relations/${relationId}/phone`);
  }

  authorize(request: AuthorizeRequest): Observable<AuthorizeResponse> {
    const authBaseUrl = this.resolveAuthBaseUrl(request.businessUnit);
    const body = new HttpParams({ fromObject: { shareId: request.shareId, relationId: request.relationId } });
    return this.httpClient.post<AuthorizeResponse>(`${authBaseUrl}/authorize`, body);
  }

  getToken(request: TokenRequest): Observable<TokenResponse> {
    const authBaseUrl = this.resolveAuthBaseUrl(request.businessUnit);
    return this.httpClient.post<TokenResponse>(`${authBaseUrl}/token`, request);
  }

  private resolveAuthBaseUrl(businessUnit: string): string {
    switch (businessUnit?.toLowerCase()) {
      case BusinessUnit.DelenLuxembourg:
        return this.config.authBaseUrl.replace(/delen\.be/, 'delen.lu');
      default:
        return this.config.authBaseUrl;
    }
  }
}
